export const appCheck24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.13342 13.1968C6.79167 14.131 9.35067 17.0512 9.35067 17.0512C9.35067 17.0512 16.0929 9.1882 17.8668 6.94391" stroke="currentColor" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'check-24'
};